import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, InputNumber, Card, Row, Col, DatePicker } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';
import { t } from '../../i18n';

export const DriverCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/drivers',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title={t('drivers.newDriver')}>
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title={t('drivers.personalInfo')}
                  help={t('drivers.personalInfoHelp')}
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('drivers.fullName')}
                    help={t('drivers.fullNameHelp')}
                  />
                }
                name="fullName"
                rules={[{ required: true, message: t('drivers.enterName') }]}
              >
                <Input placeholder={t('drivers.namePlaceholder')} />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('drivers.phoneNumber')}
                    help={t('drivers.phoneHelp')}
                  />
                }
                name="phone"
                rules={[
                  { required: true, message: t('drivers.enterPhone') },
                  { pattern: /^\+998\d{9}$/, message: "Format: +998XXXXXXXXX" },
                ]}
              >
                <Input placeholder="+998901234567" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('drivers.birthDate')}
                    help={t('drivers.birthDateHelp')}
                  />
                }
                name="birthDate"
              >
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder={t('drivers.selectDate')}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title={t('drivers.vehicleInfo')}
                  help={t('drivers.vehicleInfoHelp')}
                />
              }
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('drivers.vehicleMake')}
                        help={t('drivers.vehicleMakeHelp')}
                      />
                    }
                    name="vehicleMake"
                    rules={[{ required: true, message: t('drivers.enterMake') }]}
                  >
                    <Input placeholder={t('drivers.makePlaceholder')} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('drivers.vehicleModel')}
                        help={t('drivers.vehicleModelHelp')}
                      />
                    }
                    name="vehicleModel"
                    rules={[{ required: true, message: t('drivers.enterModel') }]}
                  >
                    <Input placeholder={t('drivers.modelPlaceholder')} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('drivers.vehicleYear')}
                        help={t('drivers.vehicleYearHelp')}
                      />
                    }
                    name="vehicleYear"
                    rules={[{ required: true, message: t('drivers.enterYear') }]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      min={2000}
                      max={2030}
                      placeholder="2020"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('drivers.vehicleColor')}
                        help={t('drivers.vehicleColorHelp')}
                      />
                    }
                    name="vehicleColor"
                    rules={[{ required: true, message: t('drivers.enterColor') }]}
                  >
                    <Input placeholder={t('drivers.colorPlaceholder')} />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('drivers.vehiclePlate')}
                    help={t('drivers.vehiclePlateHelp')}
                  />
                }
                name="vehiclePlate"
                rules={[{ required: true, message: t('drivers.enterPlate') }]}
              >
                <Input placeholder="01A123AA" style={{ textTransform: 'uppercase' }} />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('drivers.vehicleSeats')}
                    help={t('drivers.vehicleSeatsHelp')}
                  />
                }
                name="vehicleSeats"
                initialValue={4}
              >
                <InputNumber style={{ width: '100%' }} min={2} max={8} placeholder="4" />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
